import { render } from "./AndroidMain.vue?vue&type=template&id=b00755e4&scoped=true&ts=true"
import script from "./AndroidMain.vue?vue&type=script&lang=ts"
export * from "./AndroidMain.vue?vue&type=script&lang=ts"

import "./AndroidMain.vue?vue&type=style&index=0&id=b00755e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b00755e4"]])

export default __exports__